<template>
  <div class="banner-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <!-- 表格 -->
        <div class="filter-box">
          <div class="left">
            <el-input
              class="input"
              v-model="filter.name"
              style="width: 188px; margin-left: 10px"
              placeholder="此框输入关键词搜索"
              size="small"
            ></el-input>
            <div class="btn-box">
              <button class="search" @click="search">搜索</button>
              <button class="reset" @click="reset">重置</button>
            </div>
          </div>
          <div class="right">
            <div class="btn" @click="handleAddModal('add')">+ 添加触发关键词</div>
          </div>
        </div>
        <el-table
          :data="list"
          class="order-table table no-border-table"
          ref="orderTable"
          :header-cell-style="{
            border: 'none',
            color: '#333',
            background: '#f6f6f6',
            borderBottom: '1px solid #E8E8E8',
            height: '54px',
          }"
          :row-style="{
            height: '54px',
          }"
        >
          <el-table-column type="index" label="序号" width="100" align="center">
          </el-table-column>
          <el-table-column
            prop="articleTitle"
            align="center"
            label="触发关键词"
            width="200"
          ></el-table-column>
          <el-table-column prop="linkProductId" align="center" label="关联产品">
            <div slot-scope="scope">
              <span v-for="(item, index) in scope.row.linkProduct" :key="index">
                {{ item.name }}
                <span v-if="index !== scope.row.linkProduct.length - 1"
                  >、</span
                >
              </span>
            </div>
          </el-table-column>
          <el-table-column prop="linkBrandId" align="center" label="关联品牌">
            <div slot-scope="scope">
              <span v-for="(item, index) in scope.row.linkBrand" :key="index">
                {{ item.name }}
                <span v-if="index !== scope.row.linkBrand.length - 1">、</span>
              </span>
            </div>
          </el-table-column>
          <el-table-column label="操作" align="center" width="200">
            <div
              slot-scope="scope"
              style="display: flex;justify-content: center;"
            >
              <div>
                <button
                  size="mini"
                  class="table-btn"
                  @click="handleAddModal('edit', scope.row.id)"
                >
                  编辑
                </button>
              </div>
              <div>
                <button
                  size="mini"
                  class="table-btn"
                  @click="deletePlatformArticle(scope.row.id)"
                >
                  删除
                </button>
              </div>
            </div>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页按钮 -->
      <div class="footer">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          background
          layout="total, prev, pager, next, jumper"
          :page-size="size"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :visible.sync="addKeywordVisible"
      class="dialog"
      width="800px"
      top="25vh"
    >
      <div slot="title" class="dialog-title">
        添加触发关键词
      </div>
      <el-form
        ref="form"
        class="form"
        label-width="auto"
        style="padding-left: 30px;"
      >
        <el-form-item label="关键词" prop="classifyName" class="form-item">
          <el-input
            size="small"
            placeholder="请输入关键词"
            class="add-renovation-input"
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item label="关联品牌" prop="profit" class="form-item">
          <div class="category">
            <div
              class="item"
              v-for="(item, index) in selectedBrand"
              :key="index"
            >
              {{ item.brandName }}
              <div
                class="iconfont icon-shanchu"
                @click="deleteBrandSelected(index)"
              ></div>
            </div>
          </div>
          <div class="add-category" @click="addBrandModal">
            + 添加关联品牌
          </div>
        </el-form-item>
        <el-form-item label="关联产品" prop="profit" class="form-item">
          <div class="category">
            <div
              class="item"
              v-for="(item, index) in selectedGoods"
              :key="index"
            >
              {{ item.name }}
              <div
                class="iconfont icon-shanchu"
                @click="deleteGoodSelected(index)"
              ></div>
            </div>
          </div>
          <div class="add-category" @click="addGoodsModal">
            + 添加关联产品
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn btn" @click="addKeywordVisible = false"
          >取 消</el-button
        >
        <el-button class="confirm-btn btn" @click="handleConfirm"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog title="添加产品ID" width="620px" :visible.sync="addGoodsVisible">
      <div class="add-goods-dialog">
        <div class="search-box">
          输入产品ID：
          <el-input
            placeholder="请输入标题"
            class="input"
            size="small"
            @input="goodsTip = false"
            v-model="goodId"
            style="width: 240px"
          ></el-input>
          <div class="btn" @click="getGoodInfoById">
            查询
          </div>
        </div>
        <div class="tip" v-if="goodsTip">
          未查询到该ID的产品，请检查ID是否有效后重新查询
        </div>
        <el-table
          :data="goodsList"
          class="order-table table no-border-table"
          ref="orderTable"
          :header-cell-style="{
            border: 'none',
            color: '#333',
            background: '#f6f6f6',
            borderBottom: '1px solid #E8E8E8',
            height: '54px',
          }"
          :row-style="{
            height: '54px',
          }"
        >
          <el-table-column prop="masterPic" align="center" label="产品图">
            <div slot-scope="scope">
              <el-image
                class="brand-pic"
                :src="scope.row.masterPic"
                :preview-src-list="[scope.row.masterPic]"
              >
              </el-image>
            </div>
          </el-table-column>
          <el-table-column
            prop="id"
            align="center"
            label="产品ID"
          ></el-table-column>
          <el-table-column
            prop="name"
            align="center"
            label="产品名称"
          ></el-table-column>
          <el-table-column label="操作" align="center" width="100">
            <div
              slot-scope="scope"
              style="display: flex;justify-content: center;"
            >
              <div>
                <button
                  size="mini"
                  class="table-btn"
                  @click="deleteGood(scope.$index)"
                >
                  删除
                </button>
              </div>
            </div>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn cancel-btn" @click="addGoodsVisible = false"
          >取 消</el-button
        >
        <el-button class="btn confirm-btn" @click="addGoods">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="添加品牌ID" width="620px" :visible.sync="addBrandVisible">
      <div class="add-goods-dialog">
        <div class="search-box">
          输入品牌ID：
          <el-input
            placeholder="请输入标题"
            class="input"
            size="small"
            v-model="brandId"
            @input="brandTip = false"
            style="width: 240px"
          ></el-input>
          <div class="btn" @click="getBrandInfoById">
            查询
          </div>
        </div>
        <div class="tip" v-if="brandTip">
          未查询到该ID的品牌，请检查ID是否有效后重新查询
        </div>
        <el-table
          :data="brandList"
          class="order-table table no-border-table"
          ref="orderTable"
          :header-cell-style="{
            border: 'none',
            color: '#333',
            background: '#f6f6f6',
            borderBottom: '1px solid #E8E8E8',
            height: '54px',
          }"
          :row-style="{
            height: '54px',
          }"
        >
          <el-table-column prop="logo" align="center" label="logo">
            <div slot-scope="scope">
              <el-image
                class="brand-pic"
                :src="scope.row.logo"
                :preview-src-list="[scope.row.logo]"
              >
              </el-image>
            </div>
          </el-table-column>
          <el-table-column
            prop="id"
            align="center"
            label="品牌ID"
          ></el-table-column>
          <el-table-column
            prop="brandName"
            align="center"
            label="品牌名称"
          ></el-table-column>
          <el-table-column label="操作" align="center" width="100">
            <div
              slot-scope="scope"
              style="display: flex;justify-content: center;"
            >
              <div>
                <button
                  size="mini"
                  class="table-btn"
                  @click="deleteBrand(scope.$index)"
                >
                  删除
                </button>
              </div>
            </div>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn cancel-btn" @click="addBrandVisible = false"
          >取 消</el-button
        >
        <el-button class="btn confirm-btn" @click="addBrand">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
export default {
  components: {
    Header
  },
  name: 'banner',
  data() {
    return {
      currentPage: 1, // 当前页码
      size: 20, // 每页条数
      total: 0, // 总页数
      loading: 0, // 加载中
      title: {
        // 页面标题
        firstTitile: ' ',
        secondTitle: ' '
      },
      list: [], // 轮播列表
      date: [],
      articleType: 3,
      categoryType: 3,
      categoryList: [],
      filter: {
        hotBrand: 0,
        brandName: '',
        classifyId: 0,
        name: ''
      },
      addKeywordVisible: false,
      // selectedBrand: [],
      // brandList: [],
      // selectedGoods: [],
      // goodsList: [],
      addGoodsVisible: false,
      goodsList: [],
      selectedGoods: [],
      selectedGoodsPre: [],
      goodId: null,
      addBrandVisible: false,
      brandList: [],
      selectedBrand: [],
      selectedBrandPre: [],
      brandId: null,
      goodsTip: false,
      brandTip: false,
    };
  },
  mounted() {
    // 获取列表
    this.getPlatformArticleList();
  },
  computed: {},
  methods: {
    // 切换页码
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getPlatformArticleList();
    },
    search(){
      this.getPlatformArticleList();
    },
    reset(){
      this.filter = {};
      this.getPlatformArticleList();
    },
    // 获取轮播列表
    getPlatformArticleList() {
      this.loading++;
      this.httpGet(this.$root.getPlatformArticleList, {
        page: this.currentPage,
        size: this.size,
        ...this.filter,
      }).then(
        (res) => {
          this.loading--;
          this.list = res.list;
          this.total = res.total;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    // 删除
    deletePlatformArticle(id) {
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定要删除该文章吗？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpDelete(this.$root.deletePlatformArticle, {
          id
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getPlatformArticleList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    handleConfirm(){

    },
    handleAddModal(){
      this.addKeywordVisible = true;
    },
    getGoodInfoById(){
      let filterArr = this.goodsList.filter(item => item.id === +this.goodId);
      if(filterArr && filterArr.length){
        this.$message.warning('该产品已存在，请重新选择！')
        return;
      }
      this.loading++;
      this.httpGet(this.$root.getProductInfo, {
        id: this.goodId
      }).then(
        (res) => {
          this.loading--;
          if(!res.id){
            this.goodsTip = true;
            return;
          };
          this.goodsTip = false;
          this.goodsList = [...this.goodsList, res];
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    addGoodsModal(){
      this.goodsList = [];
      this.goodId = null;
      // this.goodsList = this.selectedGoods;
      this.addGoodsVisible = true;
    },
    deleteGoodSelected(index){
      this.selectedGoods.splice(index, 1);
    },
    deleteGood(index){
      this.goodsList.splice(index, 1);
    },
    addGoods(){
      // this.selectedGoods = this.goodsList;
      // this.selectedGoods = [...this.selectedGoods, ...this.goodsList];
      let list = [...this.selectedGoods, ...this.goodsList];
      this.selectedGoods = Array.from(
        new Map(list.map(item => [item.id, item])).values()
      );
      this.addGoodsVisible = false;
    },
    getBrandInfoById(){
      let filterArr = this.brandList.filter(item => item.id === +this.brandId);
      if(filterArr && filterArr.length){
        this.$message.warning('该品牌已存在，请重新选择！')
        return;
      }
      this.loading++;
      this.httpGet(this.$root.getBrandInfo, {
        id: this.brandId
      }).then(
        (res) => {
          this.loading--;
          if(!res.id){
            this.brandTip = true;
            return;
          };
          this.brandTip = false;
          this.brandList = [...this.brandList, res];
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    addBrandModal(){
      this.brandList = [];
      this.brandId = null;
      // this.brandList = this.selectedBrand;
      this.addBrandVisible = true;
    },
    deleteBrand(index){
      this.brandList.splice(index, 1);
    },
    deleteBrandSelected(index){
      this.selectedBrand.splice(index, 1);
    },
    addBrand(){
      // this.selectedBrand = [...this.selectedBrand, ...this.brandList];
      let list = [...this.selectedBrand, ...this.brandList];
      this.selectedBrand = Array.from(
        new Map(list.map(item => [item.id, item])).values()
      );
      this.addBrandVisible = false;
    },
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.banner-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 0 20px 20px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      padding: 24px 32px;
      border-radius: 2px;

      .filter-box{
        flex-x();
        .left{
          flex-x(flex-start);
        }
        .btn-box{
          margin-left: 10px;
        }
      }

      // 按钮
      .btn {
        // width: 100px;
        display: inline-block;
        padding: 0 10px;
        height: 32px;
        line-height: 32px;
        confirm-btn();
        font-size: 14px;
        margin-bottom: 16px;
        // margin: 16px 0;
      }

      .tip {
        margin-left: 32px;
        color: #999;
      }

      // 表格按钮
      .table-btn {
        width: 65px;
        height: 24px;
        line-height: 24px;
        color: gray3;
        font-size: 12px;
        margin-right: 8px;
        cancel-btn();
      }

      .brand-pic {
        height: 36px;
        width: auto;
      }
    }
    .footer {
      width: 100%;
      padding: 24px;
      box-sizing: border-box;
      flex-x(flex-end);
      background: white;
    }
  }
  .category{
    width: 600px;
    min-height: 120px;
    border-radius: 5px;
    border: 1px solid #E8E8E8;
    padding: 6px 10px;
    box-sizing: border-box;
    flex-x(flex-start, flex-start);
    flex-wrap: wrap;
    background: #F2F2F2;
    .item{
      height: 24px;
      min-width: 60px;
      padding:0 12px;
      border-radius: 2px;
      background: #fff;
      word(12px, #333);
      flex-x(center);
      margin-right: 8px;
      margin-bottom: 8px;
      position: relative;
      border: 1px solid #E6E6E6;
      div{
        line-height: 16px;
        position: absolute;
        right: -6px;
        top: -6px;
        cursor: pointer;
      }
    }
  }

  .add-category{
    // width: 80px;
    cursor: pointer;
    color: #5283FF;
    flex-x(flex-start);
    flex-shrink: 0;
  }
  .add-goods-dialog{
    .search-box{
      flex-x(center);
      .input{
        margin-left: 20px;
        margin-right: 5px;
      }
      .btn{
        width: 72px;
        height: 32px;
        border-radius: 5px;
        background: #5283FF;
        cursor: pointer;
        flex-x(center);
        word(14px, #fff);
      }
    }
    .tip{
      flex-x(center);
      margin: 15px 0;
      word(14px, #E33B3B);
    }
    .table-btn {
      width: 65px;
      height: 24px;
      line-height: 24px;
      color: gray3;
      font-size: 12px;
      margin-right: 8px;
      cancel-btn();
    }
  }
  .brand-pic{
    width: 32px;
    height: 32px;
    border-radius: 5px;
  }
}
</style>
